<template>
    <div v-if="active" class="card">        
        <a class="theme-primary help-icon icon text-right" href="login-help.html" target="_blank" alt="Login Help">
            <fa-icon :icon="['fas','question-circle']" /><span class="sr-only">login help</span>
        </a>        
        <Error ref="error" />
        <div class="card-body" @keyup.enter="clickAction">
            <PageHeader :title="screenData.text.cardTitle" variant="small" class="mb-4" />
            <div class="username-container mb-3 d-flex align-items-center">
                <h3 class="m-0 d-inline-flex">
                    <fa-icon class="theme-primary h5" :icon="['fas','user']" />
                </h3>
                <h3 class="m-0 ml-3 d-inline-flex h5">{{userId}}</h3>
            </div>
            <NewPassword :password-label="screenData.text" :user-id="userId" :verify-password-label="screenData.text.verifyPassword"
                         :requirements-label="screenData.text.passwordRequirements" @set-new-password="setNewPassword"></NewPassword>
            <ActionList :actions="screenData.actions" @reset-password="resetPassword" @cancel-reset-password="cancel"></ActionList>
        </div>
    </div>
</template>

<script>
    import { nextTick } from 'vue'
    import Error from '../entities/Error.vue';
    import NewPassword from '../entities/NewPassword.vue';
    import ActionList from '../entities/ActionList.vue';
    import PageHeader from '../entities/PageHeader.vue';
    //import {goToIndexPage} from '../../../../src/utility/miscellaneous'

    import {PostAuthHandler} from '../mixins/PostAuthHandler.js';

    export default {
        name: "ResetPassword",

        components: {
            Error,
            NewPassword,
            ActionList,
            PageHeader
        },

        mixins: [
            PostAuthHandler
        ],

        props: {
            screenData: Object
        },

        data: function() {
            return {
                active: false,
                stateToken: "",
                api: "",
                taxId: "",
                tinType: "",
                userId: "",
                accountNumber: "",
                dateOfBirth: "",
                newPassword: ""
            }
        },

        methods: {
            //goToIndexPage,
            show: function(data) {
                this.stateToken = data.stateToken;
                this.api = data.api;
                this.active = true;
                nextTick(function() {
                    this.$emitter.emit('disable','reset-password');
                    
                    if (data.error !== undefined) {
                        this.$refs["error"].display(data.error.errorCode, data.error.errorMessage, data.error.errorType);
                    }
                }.bind(this));
            },

            hide: function() {
                this.active = false;
            },

            setNewPassword: function(val) {
                this.newPassword = val;
            },

            clickAction: function() {
                if (this.newPassword !== "") {
                    this.resetPassword();
                }
            },

            resetPassword: function() {
                this.$emitter.emit('start-loading','reset-password');
                var data = {
                    cwUserIdMaint: {
                        taxId: this.taxId,
                        tinType: this.tinType,
                        userId: this.userId,
                        newPassword: this.newPassword
                    },
                    stateToken: this.stateToken
                };

                if (this.dateOfBirth !== "") {
                    data.cwUserIdMaint.customerBirthDate = this.dateOfBirth;
                }

                if (this.accountNumber !== "") {                    
                    data.cwUserIdMaint.accountNumber = this.accountNumber;
                }

                this.$axios.post(this.api, data).then(function(response) {
                    if (response.data.success) {
                        this.$refs["error"].clear();
                        if (response.data.data.status === "SUCCESS" || response.data.data.status === "MFA_ENROLL") {
                             var nextScreenData = {
                                passwordSetMsg: this.screenData.text.passwordUpdatedMsg,
                                success: response.data.success
                            };
                            //this.goToIndexPage();
                            this.$emitter.emit('navigate', { componentName: "login", routeData: nextScreenData});
                        }
                    }
                }.bind(this)).catch(function(error) {
                    if (error.response.data.messages.length > 0) {
                        var err = error.response.data.messages[0];
                        this.$refs["error"].display(err.errorCode, err.errorMessage, err.errorType);
                    }
                    this.$emitter.emit('stop-loading','reset-password');
                }.bind(this));
            },

            cancel: function() {
                this.$emitter.emit('start-loading','cancel-reset-password');
                window.location.href = window.location.href;
            },

            setPiiData: function(data) {
                this.taxId = data.taxId;
                this.tinType = data.tinType;
                this.accountNumber = data.accountNumber;
                this.dateOfBirth = data.dateOfBirth;
                this.userId = data.userId;
            }
        },

        mounted: function() {
            this.$emitter.on('set-pii-password-data', this.setPiiData);
        },

        unmounted: function() {
            this.$emitter.off('set-pii-password-data', this.setPiiData);
        },

        watch: {
            newPassword: function(val) {
                if (val === "") {
                    this.$emitter.emit('disable','reset-password');
                }
                else {                    
                    this.$emitter.emit('enable','reset-password');
                }
            }
        }
    }
</script>